export default function LoadScript(url, callback) {
  const script = document.createElement('script');
  script.type = 'text/javascript';

  // IE浏览器下
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        // 确保执行两次
        script.onreadystatechange = null;
        // todo 执行要执行的代码
        callback();
      }
    };
  } else {
    script.onload = function () {
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
